<template>
    <card
        :label-top-left="$t('msg.groups')"
        icon="mdi-currency-usd"
        class="card_max-sm p-groups"
    >
        <template v-slot:bottom>
            <filters
                    v-model="filters"
                    :bool-singles="['is_archive']"
                    name="groups"
                    :dict-value="filterDictValue"
                    :do-not-save-filters="['date_start', 'date_end']"
                    @clear="clearFilters"
            >
                <date-range
                        :date-start.sync="filters.date_start"
                        :date-end.sync="filters.date_end"
                        :label="$t('msg.dates')"
                        @change="loadModels"
                        outlined
                        dense
                        hide-details
                ></date-range>
                <v-select
                        v-model="filters.type"
                        :label="$t('msg.type')"
                        class="card__action"
                        :items="types"
                        clearable
                        outlined
                        dense
                        hide-details
                >
                    <template v-slot:selection="{item}">
                        {{ $t('typeTransaction.'+item) }}
                    </template>
                    <template v-slot:item="{item}">
                        {{ $t('typeTransaction.'+item) }}
                    </template>
                </v-select>
                <v-switch
                        v-model="filters.is_archive"
                        :label="$t('msg.inArchive')"
                        dense
                        hide-details
                ></v-switch>
            </filters>
        </template>
        <template
                slot="header"
        >
            <v-btn
                    small
                    color="primary"
                    :to="{name: 'create_group'}"
                    :fab="$vuetify.breakpoint.smAndDown"
                    elevation="0"
            >
                <v-icon
                        :class="{'mr-1': !$vuetify.breakpoint.smAndDown}"
                >mdi-plus</v-icon>
                <template v-if="!$vuetify.breakpoint.smAndDown">{{ $t('msg.toCreate') }}</template>
            </v-btn>
        </template>
        <v-data-table
                v-if="!$vuetify.breakpoint.smAndDown"
                :headers="headers"
                :items="filteredModels"
                :loading="loading"
                hide-default-footer
                :items-per-page="3000"
                class="v-data-table_small"
                sort-by="name"
                :mobile-breakpoint="0"
        >
            <template v-slot:item.stat="{item}">
                <div
                        v-for="(sum, currency) in item.stat"
                        :key="currency"
                        class="sum__row"
                >
                    <span v-if="item.type === 'income'">+</span>
                    <span v-else>-</span>
                    {{ sum | numFormat('0,0.00') }} {{ findItem(currencies, parseInt(currency), 'symbol') }}
                </div>
            </template>
            <template v-slot:item.type="{item}">
                <v-chip
                        small
                        :class="{
                            'bg-green-light': !item.is_transfer && item.type === 'income',
                            'bg-red-light': !item.is_transfer && item.type === 'expenses',
                            'bg-grey-light': item.is_transfer
                        }"
                >{{ item.is_transfer ? $t('typeTransaction.transfer') : $t('typeTransaction.'+item.type) }}</v-chip>
            </template>
            <template v-slot:item.actions="{item}">
                <actions
                        edit="edit_group"
                        :id="item.id"
                ></actions>
            </template>
            <template v-slot:body.append>
                <tr>
                    <td></td>
                    <td class="text-right p-groups__sum">
                        <div v-for="(item, currency_id) in sum.income">
                            + {{ item | numFormat('0,0.00') }} {{ findItem(currencies, parseInt(currency_id), 'symbol') }}
                        </div>
                        <div v-for="(item, currency_id) in sum.expenses">
                            - {{ item | numFormat('0,0.00') }} {{ findItem(currencies, parseInt(currency_id), 'symbol') }}
                        </div>
                    </td>
                    <td></td>
                    <td></td>
                </tr>
            </template>
        </v-data-table>
        <div v-if="$vuetify.breakpoint.smAndDown" class="mobile-table">
            <div
                    v-for="(item, key) in filteredModels"
                    :key="key"
                    class="mobile-table__item"
                    @click="$router.push({name: 'edit_group', params: {id: item.id}})"
            >
                <div class="mobile-table__left">
                    <div class="mobile-table__row">{{ item.name }}</div>
                    <div class="mobile-table__row">
                        <v-chip
                                small
                                :class="{
                                    'bg-green-light': !item.is_transfer && item.type === 'income',
                                    'bg-red-light': !item.is_transfer && item.type === 'expenses',
                                    'bg-grey-light': item.is_transfer
                                }"
                        >{{ item.is_transfer ? $t('typeTransaction.transfer') : $t('typeTransaction.'+item.type) }}</v-chip>
                    </div>
                </div>
                <div class="mobile-table__right">
                    <div class="mobile-table__row mobile-table__row_big">
                        <div
                                v-for="(sum, currency) in item.stat"
                                :key="currency"
                                class="sum__row"
                        >
                            <span v-if="item.type === 'income'">+</span>
                            <span v-else>-</span>
                            {{ sum | numFormat('0,0.00') }} {{ findItem(currencies, parseInt(currency), 'symbol') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <v-progress-linear
                v-if="loading"
                indeterminate
        ></v-progress-linear>
        <div v-if="$vuetify.breakpoint.smAndDown && !loading" class="total mt-3">
            <table>
                <tbody>
                <tr>
                    <td>{{ $t('msg.income') }}:</td>
                    <td>
                        <div v-for="(item, currency_id) in sum.income">
                            + {{ item | numFormat('0,0.00') }} {{ findItem(currencies, parseInt(currency_id), 'symbol') }}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('msg.expenses') }}:</td>
                    <td>
                        <div v-for="(item, currency_id) in sum.expenses">
                            - {{ item | numFormat('0,0.00') }} {{ findItem(currencies, parseInt(currency_id), 'symbol') }}
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </card>
</template>

<script>
    import Actions from '../../../components/ui/Actions';
    import DateRange from '../../../components/ui/DateRange';
    import Filters from '../../../components/ui/Filters';
    import { format, startOfMonth, lastDayOfMonth } from 'date-fns';

    export default {
        components: {Actions, DateRange, Filters},
        data() {
            return {
                loading: false,
                models: [],
                currencies: [],
                types: [],
                filters: {
                    type: null,
                    is_archive: false,
                    date_start: format(startOfMonth(new Date()), 'yyyy-MM-dd'),
                    date_end: format(lastDayOfMonth(new Date()), 'yyyy-MM-dd')
                }
            }
        },
        computed: {
            headers() {
                return [
                    {text: this.$t('msg.name'), value: 'name', align: 'start', sortable: true},
                    {text: this.$t('msg.incomeExpensesPerPeriod'), value: 'stat', align: 'end', sortable: true},
                    {text: this.$t('msg.type'), value: 'type', align: 'center', sortable: true},
                    {text: this.$t('msg.actions'), value: 'actions', align: 'center', sortable: false, width: 100}
                ];
            },
            filteredModels() {
                return this.models.filter(model => {

                    let filterType = () => {
                        if (this.filters.type === undefined || this.filters.type === null) return true;
                        return model.type === this.filters.type;
                    };

                    let isArchive = () => {
                        return model.is_archive === this.filters.is_archive;
                    };

                    return filterType() && isArchive();
                });
            },
            sum() {
                let ret = {
                    income: {},
                    expenses: {}
                };

                this.filteredModels.forEach((item, i) => {

                    if (item.type === 'income') {

                        for (let currency in item.stat) {

                            if (ret.income[currency] === undefined) {
                                ret.income[currency] = 0;
                            }

                            ret.income[currency] += item.stat[currency];
                        }

                    } else if (item.type === 'expenses') {

                        for (let currency in item.stat) {

                            if (ret.expenses[currency] === undefined) {
                                ret.expenses[currency] = 0;
                            }

                            ret.expenses[currency] += item.stat[currency];
                        }
                    }
                });

                return ret;
            },
            filterDictValue() {
                let type = {};

                this.types.forEach(item => {
                    type[item] = this.$t('typeTransaction.'+item);
                });

                return {
                    type,
                    date_start: (v) => {
                      return this.dateString(v);
                    },
                    date_end: (v) => {
                      return this.dateString(v);
                    }
                }
            }
        },
        methods: {
            clearFilters() {
                this.filters.date_start = format(startOfMonth(new Date()), 'yyyy-MM-dd');
                this.filters.date_end = format(lastDayOfMonth(new Date()), 'yyyy-MM-dd');
                this.filters.type = null;
                this.filters.is_archive = false;
            },
            loadModels() {
                this.loading = true;

                let req = {
                    date_start: this.filters.date_start,
                    date_end: this.filters.date_end
                };

                this.$store.dispatch('loadGroups', {params: req})
                    .then(res => this.models = res)
                    .finally(() => this.loading = false);
            },
            loadCurrencies() {
                this.$store.dispatch('loadCurrencies')
                    .then(res => this.currencies = res);
            },
            loadTypes() {
                this.$store.dispatch('loadGroupTypes')
                    .then(res => this.types = res);
            }
        },
        created() {
            this.loadModels();
            this.loadCurrencies();
            this.loadTypes();
        }
    }
</script>

<style lang="scss">
    .p-groups {
        .p-groups__sum {
            font-weight: 500;
            font-size: 12px;
        }
    }
</style>